/** Set once a reload is under way, so an error screen can keep out of its way. */
export let reloading = false;

/**
 * As close to Ctrl+Shift+R as a page can get (browsers removed `reload(true)`). index.html is
 * served without Cache-Control, so a plain reload can come back from the HTTP cache with the old
 * bundle's script tags. Fetching the page with `cache: 'reload'` goes to the server and replaces
 * the cached copy; the hashed JS/CSS it then points at are new URLs, so they load fresh anyway.
 * Cache Storage is cleared too, in case anything ever puts the shell there.
 */
export async function hardReload() {
  reloading = true;
  try {
    await fetch(window.location.href, { cache: 'reload', credentials: 'same-origin' });
    if ('caches' in window) await Promise.all((await caches.keys()).map((key) => caches.delete(key)));
  } finally {
    window.location.reload();
  }
}
